import { Button, Grid2, Snackbar, TextField, Typography,snackbar } from "@mui/material";
import TokenError from "../tokenError";
import { useEffect, useState,useRef } from "react";
import { Label } from "flowbite-react";
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import config from '../../config/config.js';
import { makeGetRequestToUrl, makePostRequestToUrl } from "../commonFunc";
import { useNavigate } from "react-router-dom";

const CorporateSettings = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [emailAlt, setEmailAlt] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailAltError, setEmailAltError] = useState(false);
    const [phone, setPhone] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [debtLimit, setDebtLimit] = useState('');
    const [userLimit, setUserLimit] = useState('');
    const [peruserRideLimit, setPeruserRideLimit] = useState('');
    const [peruserSpendLimit, setPeruserSpendLimit] = useState('');
    const [monthlyRideLimit, setMonthlyRideLimit] = useState('');
    const [monthlyTransactionLimit, setMonthlyTransactionLimit] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [rows, setRows] = useState([]);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const originalRef = useRef({}); // values as fetched, for diffing on save

    const corporateIdFromLocal = localStorage.getItem('corporateId');

    const validateEmail = (email) => {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(String(email).toLowerCase());
    };

    const fetchCorporateSettingsData = async () => {
        try {
            const url = serverUrl + '/corporates/fetch_all';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };

            if (corporateIdFromLocal && corporateIdFromLocal != 0) {
                body.corporate_id = corporateIdFromLocal;
            }

            const response = await makeGetRequestToUrl(url, body);
            if (response.flag == 200) {
                console.log('response', response.data);
                setRows(response.data);
                setCompanyName(response.data[0].name);
                setEmail(response.data[0].email);
                setEmailAlt(response.data[0].alternative_email);
                setPhone(response.data[0].phone_number);
                setCurrentPassword(response.data[0].current_password);
                setNewPassword(response.data[0].new_password);
                setConfirmPassword(response.data[0].confirm_password);
                setDebtLimit(response.data[0].debt_limit);
                setUserLimit(response.data[0].user_limit);
                setPeruserRideLimit(response.data[0].per_user_ride_limit);
                setPeruserSpendLimit(response.data[0].per_user_spend_limit);
                setMonthlyRideLimit(response.data[0].monthly_ride_limit);
                setMonthlyTransactionLimit(response.data[0].monthly_transaction_limit);
                const d = response.data[0];
                originalRef.current = {
                    name: d.name ?? '',
                    email: d.email ?? '',
                    phone_number: d.phone_number ?? '',
                    per_user_ride_limit: d.per_user_ride_limit ?? '',
                    per_user_spend_limit: d.per_user_spend_limit ?? '',
                };
            }
            if (response.flag == 102) {
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
        const handleSessionExpired = () => {
        localStorage.removeItem('token');
        setErrorMessage('Your session has expired. Please log in again.');
        setTokenExpired(true);
        setTimeout(() => { navigate('/signup'); }, 2000);
    };

    const saveSettings = async () => {
        if (emailError) {
            setMessage('Please enter a valid email address');
            showSnackbar(true);
            return;
        }
        if(emailAltError){
            setMessage('Please enter a valid alternative email address');
            showSnackbar(true);
            return;
        }

        const current = {
            name: companyName ?? '',
            email: email ?? '',
            alternative_email: emailAlt ?? '',
            phone_number: phone ?? '',
            per_user_ride_limit: peruserRideLimit ?? '',
            per_user_spend_limit: peruserSpendLimit ?? '',
        };

        // Only fields whose value differs from what was fetched
        const changed = {};
        Object.keys(current).forEach((key) => {
            if (String(current[key]) !== String(originalRef.current[key] ?? '')) {
                changed[key] = current[key];
            }
        });

        if (Object.keys(changed).length === 0) {
            setMessage('Nothing to update.');
            showSnackbar(true);
            return;
        }

        try {
            const url = operationsUrl + '/corporates/add_update_corporates';
            const payload = { token, corporate_id: corporateIdFromLocal, ...changed };
            const response = await makePostRequestToUrl(url, payload);

            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                fetchCorporateSettingsData(); // refreshes the snapshot too
            } else if (response.flag == 102) {
                handleSessionExpired();
            } else {
                setMessage(response.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error saving settings:', error);
            setMessage('An error occurred');
            showSnackbar(true);
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') return;
        showSnackbar(false);
    };

    useEffect(() => {
        fetchCorporateSettingsData();
    }, []);

    const handleSubmit = async () => {
        try {
            const token = localStorage.getItem('token');
            const payload = {
                token: token,
                
            };
            
            let url = operationsUrl + '/admin-panel/update_corporate_settings';
            
            const response = await makePostRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                fetchCorporateSettingsData();
            } else {
                setMessage(response.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.error(`Error`, error);
            setMessage(`An error occurred`);
            showSnackbar(true);
        } finally {
            handleClose();
        }
    };

    const handleClose = () => {
        setCompanyName(rows.company_name);
        setEmail(rows.email);
        setEmailAlt(rows.alternative_email);
        setPhone(rows.phone);
        setCurrentPassword(rows.current_password);
        setNewPassword(rows.new_password);
        setConfirmPassword(rows.confirm_password);
    };

    const inputStyle = { height: '50px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius: '8px' };
    const readOnlyStyle = { ...inputStyle, backgroundColor: '#F3F3F3' };

    return (
        <div>
            {tokenExpired && (<TokenError />)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Profile Settings
            </Typography>

            {/* Company details */}
            <Grid2 sx={{ margin: '4px', backgroundColor: '#fff', borderRadius: '8px', padding: '12px', marginTop: '12px' }}>
                <Typography sx={{ color: '#4E545D', fontSize: '24px' }}>Company Details</Typography>

                <Grid2 container sx={{ marginTop: '12px' }} spacing={4} size={12}>
                    <Grid2 size={6}>
                        <Label>Company Name<span style={{ color: 'red' }}>*</span></Label>
                        <TextField sx={{ marginTop: '1%' }}
                            placeholder="Company Name" fullWidth variant="outlined" type="text"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            InputProps={{ style: inputStyle }}
                        />
                    </Grid2>

                    <Grid2 size={6}>
                        <Label>Email ID<span style={{ color: 'red' }}>*</span></Label>
                        <TextField sx={{ marginTop: '1%' }}
                            placeholder="Email" fullWidth variant="outlined" type="email"
                            value={email}
                            error={emailError}
                            disabled
                            helperText={emailError ? 'Please enter a valid email address' : ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setEmail(value);
                                setEmailError(!validateEmail(value) && value !== '');
                            }}
                            InputProps={{ style: inputStyle }}
                        />
                    </Grid2>

                    <Grid2 size={6}>
                        <Label>Alternative Email ID<span style={{ color: 'red' }}>*</span></Label>
                        <TextField sx={{ marginTop: '1%' }}
                            placeholder="Alternative Email" fullWidth variant="outlined" type="email"
                            value={emailAlt}
                            error={emailAltError}
                            helperText={emailAltError ? 'Please enter a valid Alternative email address' : ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setEmailAlt(value);
                                setEmailAltError(!validateEmail(value) && value !== '');
                            }}
                            InputProps={{ style: inputStyle }}
                        />
                    </Grid2>

                    <Grid2 size={6}>
                        <Label>Mobile Number</Label>
                        <PhoneInput
                            defaultCountry="IN" value={phone}
                            onChange={(value) => {
                                setPhone(value);
                                try {
                                    const parsed = parsePhoneNumber(value);
                                    if (parsed) {
                                        setCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                    }
                                } catch (err) {
                                    console.error('Invalid phone number:', err);
                                    setCountryCode('');
                                }
                            }}
                            placeholder="Enter phone number"
                            style={{ height: '50px', fontSize: '16px', borderRadius: '8px', alignItems: 'normal', marginTop: '1%' }}
                        />
                    </Grid2>
                </Grid2>
            </Grid2>

            {/* Limits */}
            <Grid2 sx={{ margin: '4px', backgroundColor: '#fff', borderRadius: '8px', padding: '12px', marginTop: '12px' }}>
                <Typography sx={{ color: '#4E545D', fontSize: '24px' }}>Corporate Limits</Typography>

                <Grid2 container sx={{ marginTop: '12px' }} spacing={4} size={12}>
                    <Grid2 size={6}>
                        <Label>Per User Ride Limit<span style={{ color: 'red' }}>*</span></Label>
                        <TextField sx={{ marginTop: '1%' }}
                            placeholder="Max Ride Limit" fullWidth variant="outlined" type="number"
                            value={peruserRideLimit ?? ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) setPeruserRideLimit(value);
                            }}
                            InputProps={{ inputProps: { min: 0 }, style: inputStyle }}
                        />
                    </Grid2>

                    <Grid2 size={6}>
                        <Label>Per User Spend Limit<span style={{ color: 'red' }}>*</span></Label>
                        <TextField sx={{ marginTop: '1%' }}
                            placeholder="Max Spend Limit" fullWidth variant="outlined" type="number"
                            value={peruserSpendLimit ?? ''}
                            onChange={(e) => setPeruserSpendLimit(e.target.value)}
                            InputProps={{ inputProps: { min: 0 }, style: inputStyle }}
                        />
                    </Grid2>

                    {/* <Grid2 size={6}>
                        <Label>Monthly Ride Limit</Label>
                        <TextField sx={{ marginTop: '1%' }}
                            fullWidth variant="outlined" type="text"
                            value={monthlyRideLimit ?? ''}
                            InputProps={{ readOnly: true, style: readOnlyStyle }}
                        />
                    </Grid2>

                    <Grid2 size={6}>
                        <Label>Monthly Transaction Limit</Label>
                        <TextField sx={{ marginTop: '1%' }}
                            fullWidth variant="outlined" type="text"
                            value={monthlyTransactionLimit ?? ''}
                            InputProps={{ readOnly: true, style: readOnlyStyle }}
                        />
                    </Grid2> */}
                </Grid2>
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', marginBottom: '2%' }}>
                <Button
                    variant="contained"
                    onClick={saveSettings}
                    sx={{ width: '140px', height: '50px', textTransform: 'none', boxShadow: 'none',
                        fontSize: '16px', backgroundColor: '#0065FF', color: 'white', borderRadius: '10px' }}
                >
                    Update
                </Button>
            </div>
            </Grid2>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message} />
        </div>
    );
};

export default CorporateSettings;
